<template>
  <div class="record-time" id="recordtitle">
    <!-- <sidebar @event="formChild"></sidebar> -->
    <div class="topview">
      <span class="top">互联互通充电记录</span>
    </div>
    <div class="lowerview">
      <div class="centerview">
        <el-row>
          <el-col style="text-align: left" :span="21">
            <ul>
              <li>
                <el-input
                  placeholder="请输入订单号"
                  v-model="orderNum"
                  clearable
                ></el-input>
              </li>

              <li>
                <el-select
                  v-model="customer"
                  clearable
                  placeholder="请选择客户归属运营商"
                >
                  <el-option
                    v-for="item in customerList"
                    :key="item.operator_id"
                    :label="item.company"
                    :value="item.operator_id"
                  ></el-option>
                </el-select>
              </li>

              <li>
                <el-select
                  v-model="equipment"
                  clearable
                  placeholder="请选择设备归属运营商"
                >
                  <el-option
                    v-for="item in equipmentList"
                    :key="item.operator_id"
                    :label="item.company"
                    :value="item.operator_id"
                  ></el-option>
                </el-select>
              </li>

              <li>
                <el-select
                  v-model="site"
                  clearable
                  placeholder="请选择互联站点"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.station_id"
                    :label="item.station_name"
                    :value="item.station_id"
                  ></el-option>
                </el-select>
              </li>

              <li>
                <el-date-picker
                  v-model="statrttime_value"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择开始时间"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </li>

              <li>
                <el-date-picker
                  v-model="endtime_value"
                  type="datetime"
                  placeholder="请选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </li>
            </ul>
          </el-col>
          <el-col style="text-align: left" :span="3">
            <el-button class="btn btn-left btn-all" @click="querybtnClick()"
              >查询</el-button
            >

            <el-button class="btn btn-left btn-all" @click="getOutClick()"
              >导出</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="bottomviewtwo">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
          style="width: 100%"
        >
          <el-table-column
            align="left"
            prop="start_charge_seq"
            label="订单号"
            width="240"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.start_charge_seq || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="customer_operator_name"
            label="客户归属运营商"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.customer_operator_name || "--" }}</span>
            </template></el-table-column
          >
          <el-table-column
            align="left"
            prop="operator_name"
            label="设备归属运营商"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.operator_name || "--" }}</span>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="site_name"
            label="互联站点"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.site_name || "--" }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" prop="total_money" label="总金额">
            <template slot-scope="scope">
              <span>{{ scope.row.total_money || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="elce_fee_discount"
            label="折后总金额"
            width="85"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.elce_fee_discount || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="total_power" label="总充电量">
            <template slot-scope="scope">
              <span>{{ scope.row.total_power || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="total_elec_money" label="电费">
            <template slot-scope="scope">
              <span>{{ scope.row.total_elec_money || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="total_sevice_money"
            label="服务费"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.total_sevice_money || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">启动中</span>
              <span v-else-if="scope.row.status == 2">充电中</span>
              <span v-else-if="scope.row.status == 3">停止中</span>
              <span v-else-if="scope.row.status == 4">已结束</span>
              <span v-else-if="scope.row.status == 5">未知</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="start_time"
            label="开始时间"
            width="140"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.start_time || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="end_time"
            label="结束时间"
            width="140"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.end_time || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="cutpagesview">
        <el-pagination
          @current-change="changePage"
          class="pageinclass"
          background
          :page-size="12"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import API_ROOT from "../../../config/dev.env";
export default {
  data() {
    return {
      statrttime_value: "",
      endtime_value: "",
      customer: "",
      customerList: [],
      equipment: "",
      equipmentList: [],
      site: "",
      siteList: [],
      orderNum: "",
      total: 0, //这个是总共有多少条数据
      pagesize: 12, //每页显示条目个数
      currentPage: 1, //当前页数
      tableData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.start_date || time.getTime() > Date.now()
          );
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    window.document
      .querySelector("body")
      .setAttribute("style", "background-color:#f8f8f8");
    window.document
      .querySelector("body")
      .setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  mounted() {
    this.$nextTick(function () {
      this.defaultTime();
      this.getcharents();
      this.getdataList();
    });
  },
  beforeDestroy() {},

  methods: {
    getOutClick() {
      let startTime=new Date( this.statrttime_value).getTime()
      let endTime=new Date( this.endtime_value).getTime()
      let url =
      // "api.php/index/icn_order_export"
        "api.php/index/icn_order_export?start_charge_seq="+
        this.orderNum +
        "&operator_id=" +
        this.equipment +
        "&customer_operator_id=" +
        this.customer +
        "&station_id=" +
        this.site +
        "&start_time=" +
        startTime +
        "&end_time=" +
        endTime;
      this.createAndDownloadFile(url);
    },
    createAndDownloadFile(content) {
      let link = document.createElement("a");
      content=JSON.parse(API_ROOT.API_ROOT)+"/"+content
      link.href = content;
      link.click();
    },
    defaultTime() {
      // var timestamp = new Date().getTime(); //毫秒
      // timestamp = timestamp - 1* 24 * 3600 * 1000;
      var d = new Date();

      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth() + 1) +
        "-" +
        this.checkTime(d.getDate()) +
        " 00:00:00"
      this.statrttime_value = start_date;

      this.start_date = start_date;

      var d1 = new Date();
      let end_date =
        d1.getFullYear() +
        "-" +
        this.checkTime(d1.getMonth() + 1) +
        "-" +
        this.checkTime(d1.getDate()) +
        " " +
        this.checkTime(d1.getHours()) +
        ":" +
        this.checkTime(d1.getMinutes()) +
        ":" +
        this.checkTime(d1.getSeconds());

      this.endtime_value = end_date;
    },
    getcharents() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "icnSupplierList",
      };
      this.$api({
        method: "POST",
        url: "/api.php/icnCharge/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.customerList = res.data.data.lists;
          this.equipmentList = res.data.data.lists;
          this.siteList = res.data.data.list_station;
        }
      });
    },
    getdataList() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "icnOrderList",
        page_size: this.pagesize,
        page: this.currentPage,
        start_charge_seq: this.orderNum,
        operator_id: this.equipment,
        customer_operator_id: this.customer,
        station_id: this.site,
        start_time: new Date( this.statrttime_value).getTime(),
        end_time: new Date( this.endtime_value).getTime(),
      };
      this.$api({
        method: "POST",
        url: "/api.php/icnCharge/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.tableData = res.data.data.lists;
          this.total = Number(res.data.data.counts);
        }
      });
    },

    changePage(val) {
      this.currentPage = val;
      this.getdataList();
    },

    querybtnClick() {
      this.getdataList();
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
  },
};
</script>

<style scoped lang="scss">
.record-time {
  width: 98%;
  margin: 1%;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }
}

.topview {
  height: 60px;
  color: #0071bd;
  background-color: white;
  text-align: left;
  span {
    margin-left: 13px;
    line-height: 60px;
    font-weight: bold;
  }
}
.lowerview {
  overflow: hidden;
  clear: both;
  background-color: white;
  margin-top: 10px;
  // padding: 1%;
  // padding-top: 15px;
}
.centerview {
  padding: 1%;
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    float: left;
    width: 230px;
    margin: 5px 5px 5px 0;
    .el-select {
      width: 100%;
    }
    .el-input {
      width: 100%;
    }
  }

  .btn {
    border: none;
    color: #ffffff;
    margin-top: 5px;
  }
  .btn-all {
    margin-left: 1%;
    background-color: #0177bd;
  }
  .btn-all:active {
    background-color: #409eff;
  }
}

.querybutton {
  width: 80px;
  height: 35px;
  background-color: #0071bd;
  color: white;
  display: inline-block;
  text-align: center;
  border: none;
  padding: 0;
}
.querybutton:active {
  background-color: #409eff;
}
.record-time {
  .search:active {
    background-color: #409eff;
  }
}
.exportbutton {
  width: 80px;
  height: 35px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
  padding: 0;
}
.exportbutton.active {
  background-color: #a5a5a5;
}
.exportbutton.active:hover {
  background-color: #a5a5a5;
}

.bottomviewtwo {
  padding: 1%;
  margin-top: 15px;
  .btn01 {
    color: #0061ae;
  }
  .btn02 {
    color: #e60000;
  }
  .btn03 {
    color: #009a5b;
  }
  .btn04 {
    color: #e9c15b;
  }
  .btn05 {
    color: #999999;
  }
}

.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}

h1,
h2 {
  font-weight: normal;
  color: #fff;
}

a {
  color: #42b983;
}
</style>
<style lang="scss">
.record-time {
  .bottomviewtwo {
    .el-table__row.hover-row {
      .btn01 {
        color: #ffffff;
      }
      .btn02 {
        color: #ffffff;
      }
      .btn03 {
        color: #ffffff;
      }
      .btn04 {
        color: #ffffff;
      }
      .btn05 {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/chargeManagement/interConnect.vue